import { useCallback, useEffect, useRef } from 'react';

export function useAnimationFrameScheduler(callback: () => void) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  const frameRef = useRef<number | null>(null);
  const schedule = useCallback(() => {
    if (frameRef.current !== null) return;

    frameRef.current = requestAnimationFrame(() => {
      frameRef.current = null;
      callbackRef.current();
    });
  }, []);

  useEffect(
    () => () => {
      if (frameRef.current !== null) {
        cancelAnimationFrame(frameRef.current);
        frameRef.current = null;
      }
    },
    []
  );

  return schedule;
}
